import { connect } from 'react-redux';

import AddToCartSuccessModal from '../components/AddToCartSuccessModal';
import { hideAddToCartMessage } from '../actions';

const mapStateToProps = state => {
  return {
    quantity: state.addToCartSuccessQuantity,
  };
};

const mapDispatchToProps = dispatch => ({
  hide: () => {
    dispatch(hideAddToCartMessage());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddToCartSuccessModal);
